import { ContentType } from "./http-client";

export class BuildingExpenses {
  constructor(http) {
    this.http = http;
  }

  create = (data, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  listByRental = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses/rental/${rentalId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  listByProperty = (propertyId, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses/property/${propertyId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  getById = (id, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  update = (id, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  applySplit = (id, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses/${id}/apply-split`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  parse = (data, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses/parse`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  calculateSplit = (data, params = {}) =>
    this.http.request({
      path: `/api/rentals/building-expenses/calculate-split`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
